/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { AaiChannelBindings } from '../../models/AaiChannelBindings';
import { AaiChannelBindingsDefinition } from '../../models/AaiChannelBindingsDefinition';
import { AaiChannelItem } from '../../models/AaiChannelItem';
import { AaiComponents } from '../../models/AaiComponents';
import { AaiContact } from '../../models/AaiContact';
import { AaiCorrelationId } from '../../models/AaiCorrelationId';
import { AaiDocument } from '../../models/AaiDocument';
import { AaiExternalDocumentation } from '../../models/AaiExternalDocumentation';
import { AaiHeaderItem } from '../../models/AaiHeaderItem';
import { AaiInfo } from '../../models/AaiInfo';
import { AaiLicense } from '../../models/AaiLicense';
import { AaiMessage } from '../../models/AaiMessage';
import { AaiMessageBindings } from '../../models/AaiMessageBindings';
import { AaiMessageBindingsDefinition } from '../../models/AaiMessageBindingsDefinition';
import { AaiMessageTrait } from '../../models/AaiMessageTrait';
import { AaiMessageTraitDefinition } from '../../models/AaiMessageTraitDefinition';
import { AaiOAuthFlows } from '../../models/AaiOAuthFlows';
import { AaiOperation } from '../../models/AaiOperation';
import { AaiOperationBindings } from '../../models/AaiOperationBindings';
import { AaiOperationBindingsDefinition } from '../../models/AaiOperationBindingsDefinition';
import { AaiOperationTrait } from '../../models/AaiOperationTrait';
import { AaiOperationTraitDefinition } from '../../models/AaiOperationTraitDefinition';
import { AaiParameter } from '../../models/AaiParameter';
import { AaiSchema } from '../../models/AaiSchema';
import { AaiSecurityRequirement } from '../../models/AaiSecurityRequirement';
import { AaiSecurityScheme } from '../../models/AaiSecurityScheme';
import { AaiServer } from '../../models/AaiServer';
import { AaiServerBindings } from '../../models/AaiServerBindings';
import { AaiServerBindingsDefinition } from '../../models/AaiServerBindingsDefinition';
import { AaiServerVariable } from '../../models/AaiServerVariable';
import { AaiTag } from '../../models/AaiTag';
import { IAaiNodeFactory } from '../../models/IAaiNodeFactory';
import { Node } from '../../../core/models/Node';
import { Aai20ChannelItem } from './Aai20ChannelItem';
import { Aai20Components } from './Aai20Components';
import { Aai20Contact } from './Aai20Contact';
import { Aai20CorrelationId } from './Aai20CorrelationId';
import { Aai20Document } from './Aai20Document';
import { Aai20ExternalDocumentation } from './Aai20ExternalDocumentation';
import { Aai20HeaderItem } from './Aai20HeaderItem';
import { Aai20Info } from './Aai20Info';
import { Aai20License } from './Aai20License';
import { Aai20Message } from './Aai20Message';
import { Aai20MessageTrait } from './Aai20MessageTrait';
import { Aai20MessageTraitDefinition } from './Aai20MessageTraitDefinition';
import { Aai20OAuthFlows } from './Aai20OAuthFlows';
import { Aai20Operation } from './Aai20Operation';
import { Aai20OperationTrait } from './Aai20OperationTrait';
import { Aai20OperationTraitDefinition } from './Aai20OperationTraitDefinition';
import { Aai20Parameter } from './Aai20Parameter';
import { Aai20SecurityRequirement } from './Aai20SecurityRequirement';
import { Aai20SecurityScheme } from './Aai20SecurityScheme';
import { Aai20Server } from './Aai20Server';
import { Aai20ServerVariable } from './Aai20ServerVariable';
import { Aai20Tag } from './Aai20Tag';
import { Aai20ServerBindings } from './Aai20ServerBindings';
import { Aai20ServerBindingsDefinition } from './Aai20ServerBindingsDefinition';
import { Aai20OperationBindings } from './Aai20OperationBindings';
import { Aai20OperationBindingsDefinition } from './Aai20OperationBindingsDefinition';
import { Aai20MessageBindings } from './Aai20MessageBindings';
import { Aai20MessageBindingsDefinition } from './Aai20MessageBindingsDefinition';
import { Aai20ChannelBindings } from './Aai20ChannelBindings';
import { Aai20ChannelBindingsDefinition } from './Aai20ChannelBindingsDefinition';
import { Aai20SchemaDefinition } from './Aai20SchemaDefinition';

/**
 * @author Jakub Senko<jsenko@redhat.com>
 * @class
 */
export class Aai20NodeFactory implements IAaiNodeFactory {
    /**
     * 
     * @param {Node} parent
     * @param {string} key
     * @return {AaiChannelItem}
     */
    public createChannelItem(parent : Node, key : string) : AaiChannelItem {
        return new Aai20ChannelItem(parent, key);
    }

    /**
     * 
     * @param {Node} parent
     * @return {AaiComponents}
     */
    public createComponents(parent : Node) : AaiComponents {
        return new Aai20Components(parent);
    }

    /**
     * 
     * @param {Node} parent
     * @return {AaiContact}
     */
    public createContact(parent : Node) : AaiContact {
        return new Aai20Contact(parent);
    }

    /**
     * 
     * @param {Node} parent
     * @param {string} key
     * @return {AaiCorrelationId}
     */
    public createCorrelationId(parent : Node, key : string) : AaiCorrelationId {
        return new Aai20CorrelationId(parent, key);
    }

    /**
     * 
     * @return {AaiDocument}
     */
    public createDocument() : AaiDocument {
        return new Aai20Document();
    }

    /**
     * 
     * @param {Node} parent
     * @return {AaiExternalDocumentation}
     */
    public createExternalDocumentation(parent : Node) : AaiExternalDocumentation {
        return new Aai20ExternalDocumentation(parent);
    }

    /**
     * 
     * @param {Node} parent
     * @return {AaiHeaderItem}
     */
    public createHeaderItem(parent : Node) : AaiHeaderItem {
        return new Aai20HeaderItem(parent);
    }

    /**
     * 
     * @param {Node} parent
     * @return {AaiInfo}
     */
    public createInfo(parent : Node) : AaiInfo {
        return new Aai20Info(parent);
    }

    /**
     * 
     * @param {Node} parent
     * @return {AaiLicense}
     */
    public createLicense(parent : Node) : AaiLicense {
        return new Aai20License(parent);
    }

    /**
     * 
     * @param {Node} parent
     * @param {string} key
     * @return {AaiMessage}
     */
    public createMessage(parent : Node, key : string) : AaiMessage {
        return new Aai20Message(parent, key);
    }

    /**
     * 
     * @param {Node} parent
     * @param {string} key
     * @return {AaiMessageTrait}
     */
    public createMessageTrait(parent : Node, key : string) : AaiMessageTrait {
        return new Aai20MessageTrait(parent, key);
    }

    /**
     * 
     * @param {Node} parent
     * @param {string} key
     * @return {AaiMessageTraitDefinition}
     */
    public createMessageTraitDefinition(parent : Node, key : string) : AaiMessageTraitDefinition {
        return new Aai20MessageTraitDefinition(parent, key);
    }

    /**
     * 
     * @param {Node} parent
     * @return {AaiOAuthFlows}
     */
    public createOAuthFlows(parent : Node) : AaiOAuthFlows {
        return new Aai20OAuthFlows(parent);
    }

    /**
     * 
     * @param {Node} parent
     * @param {string} key
     * @return {AaiOperation}
     */
    public createOperation(parent : Node, key : string) : AaiOperation {
        return new Aai20Operation(parent, key);
    }

    /**
     * 
     * @param {Node} parent
     * @param {string} key
     * @return {AaiOperationTrait}
     */
    public createOperationTrait(parent : Node, key : string) : AaiOperationTrait {
        return new Aai20OperationTrait(parent, key);
    }

    /**
     * 
     * @param {Node} parent
     * @param {string} key
     * @return {AaiOperationTraitDefinition}
     */
    public createOperationTraitDefinition(parent : Node, key : string) : AaiOperationTraitDefinition {
        return new Aai20OperationTraitDefinition(parent, key);
    }

    /**
     * 
     * @param {Node} parent
     * @param {string} key
     * @return {AaiParameter}
     */
    public createParameter(parent : Node, key : string) : AaiParameter {
        return new Aai20Parameter(parent, key);
    }

    /**
     * 
     * @param {Node} parent
     * @return {AaiSecurityRequirement}
     */
    public createSecurityRequirement(parent : Node) : AaiSecurityRequirement {
        return new Aai20SecurityRequirement(parent);
    }

    /**
     * 
     * @param {Node} parent
     * @param {string} key
     * @return {AaiSecurityScheme}
     */
    public createSecurityScheme(parent : Node, key : string) : AaiSecurityScheme {
        return new Aai20SecurityScheme(parent, key);
    }

    /**
     * 
     * @param {Node} parent
     * @param {string} key
     * @return {AaiServer}
     */
    public createServer(parent : Node, key : string) : AaiServer {
        return new Aai20Server(parent, key);
    }

    /**
     * 
     * @param {Node} parent
     * @param {string} key
     * @return {AaiServerVariable}
     */
    public createServerVariable(parent : Node, key : string) : AaiServerVariable {
        return new Aai20ServerVariable(parent, key);
    }

    /**
     * 
     * @param {Node} parent
     * @return {AaiTag}
     */
    public createTag(parent : Node) : AaiTag {
        return new Aai20Tag(parent);
    }

    /**
     * 
     * @param {Node} parent
     * @return {AaiServerBindings}
     */
    public createServerBindings(parent : Node) : AaiServerBindings {
        return new Aai20ServerBindings(parent);
    }

    /**
     * 
     * @param {Node} parent
     * @param {string} key
     * @return {AaiServerBindingsDefinition}
     */
    public createServerBindingsDefinition(parent : Node, key : string) : AaiServerBindingsDefinition {
        return new Aai20ServerBindingsDefinition(parent, key);
    }

    /**
     * 
     * @param {Node} parent
     * @return {AaiOperationBindings}
     */
    public createOperationBindings(parent : Node) : AaiOperationBindings {
        return new Aai20OperationBindings(parent);
    }

    /**
     * 
     * @param {Node} parent
     * @param {string} key
     * @return {AaiOperationBindingsDefinition}
     */
    public createOperationBindingsDefinition(parent : Node, key : string) : AaiOperationBindingsDefinition {
        return new Aai20OperationBindingsDefinition(parent, key);
    }

    /**
     * 
     * @param {Node} parent
     * @return {AaiMessageBindings}
     */
    public createMessageBindings(parent : Node) : AaiMessageBindings {
        return new Aai20MessageBindings(parent);
    }

    /**
     * 
     * @param {Node} parent
     * @param {string} key
     * @return {AaiMessageBindingsDefinition}
     */
    public createMessageBindingsDefinition(parent : Node, key : string) : AaiMessageBindingsDefinition {
        return new Aai20MessageBindingsDefinition(parent, key);
    }

    /**
     * 
     * @param {Node} parent
     * @return {AaiChannelBindings}
     */
    public createChannelBindings(parent : Node) : AaiChannelBindings {
        return new Aai20ChannelBindings(parent);
    }

    /**
     * 
     * @param {Node} parent
     * @param {string} key
     * @return {AaiChannelBindingsDefinition}
     */
    public createChannelBindingsDefinition(parent : Node, key : string) : AaiChannelBindingsDefinition {
        return new Aai20ChannelBindingsDefinition(parent, key);
    }

    /**
     * 
     * @param {Node} parent
     * @param {string} key
     * @return {AaiSchema}
     */
    public createSchemaDefinition(parent : Node, key : string) : AaiSchema {
        return new Aai20SchemaDefinition(parent, key);
    }

    constructor() {
    }
}
Aai20NodeFactory["__class"] = "io.apicurio.datamodels.asyncapi.v2.models.Aai20NodeFactory";
Aai20NodeFactory["__interfaces"] = ["io.apicurio.datamodels.asyncapi.models.IAaiNodeFactory"];




